import React, { memo, useCallback, useMemo } from 'react';

import ScrollingText from '../../ScrollingText/ScrollingText';
import styles from './styles.module.css';
import { getValueByLanguage } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../../utils/Constants';
import { MultilingualType, OrderTicket } from 'types';
import { Theme } from 'redux/reducers/rootReducer';

interface TopContentProps {
    currentTheme: Theme;
    orderTicket: OrderTicket;
    ticketNameFontSize: string | number;
    ticketName: string;
    activeThemeIndex: number;
}

const TopContent: React.FC<TopContentProps> = ({
    currentTheme,
    orderTicket,
    ticketNameFontSize,
    ticketName,
    activeThemeIndex,
}) => {
    const { i18n } = useTranslation();
    const l = useCallback(
        (text?: MultilingualType | null) => {
            return getValueByLanguage(text, activeThemeIndex === 0 ? i18n.language : 'ja');
        },
        [activeThemeIndex, i18n.language],
    );

    const fontFamily = useMemo(() => {
        return LANGUAGES.find((item) => (activeThemeIndex === 0 ? item.key === i18n.language : item.key === 'ja'))
            ?.fontFamily;
    }, [activeThemeIndex, i18n.language]);
    return (
        <div className={styles.textArea} style={{ color: currentTheme?.colorFontTop, fontFamily }}>
            <h2 className={styles.operatorName}>{l(orderTicket.operatorName)}</h2>
            <h1 className={styles.ticketName} style={{ fontSize: ticketNameFontSize }}>
                {ticketName}
            </h1>
            {orderTicket.subtitle && (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ScrollingText width={'90%'} delay={1000} pause={1000} canAnimate={true}>
                        {l(orderTicket.subtitle)}
                    </ScrollingText>
                </div>
            )}
        </div>
    );
};

export default memo(TopContent);
